<template>
  <div ref="editor"></div>
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import Quill from 'quill'

// ✅ IMPORTS CSS CLASSIQUES (TS OK)
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
// import 'quill/dist/quill.bubble.css' // si besoin

@Component
export default class RichTextEditor extends Vue {

  @Prop({ type: String, default: '' })
  readonly value!: string

  @Prop({ type: Object, default: () => ({}) })
  readonly options!: Record<string, any>

  private quill: Quill | null = null
  private isUpdatingFromModel = false

  mounted () {
    this.quill = new Quill(this.$refs.editor as HTMLElement, {
      theme: 'snow',
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline'],
          [{ list: 'ordered' }, { list: 'bullet' }],
          ['link'],
          ['clean']
        ]
      },
      ...this.options
    })

    // Init value
    this.quill.clipboard.dangerouslyPasteHTML(this.value || '')

    // v-model
    this.quill.on('text-change', () => {
      if (this.isUpdatingFromModel) return
      this.$emit('input', this.quill!.root.innerHTML)
    })
  }

  @Watch('value')
  onValueChange (val: string) {
    if (!this.quill) return

    const current = this.quill.root.innerHTML
    if (val !== current) {
      this.isUpdatingFromModel = true
      this.quill.clipboard.dangerouslyPasteHTML(val || '')
      this.isUpdatingFromModel = false
    }
  }

  beforeDestroy () {
    this.quill = null
  }
}
</script>

<style scoped>
.ql-editor {
  min-height: 120px;
}
</style>
